import React, { Suspense } from "react";
import PrivateRoute from "./proteoark/constants/PrivateRoute";
import PrivateRouteAdmin from "./ciods/constants/PrivateRouteAdmin";
import { tabs } from "@nextui-org/react";
import { path } from "d3";

import ViralOm from "./ViralOmics/pages/ViralOm";
import ConnectApp from "./ciodsconnect/App";

//CIODS ROUTES
const Ciods = React.lazy(() => import("./ciods/pages/Ciods"));
const CiodsHome = React.lazy(() => import("./ciods/pages/CiodsHome"));
const CiodsPublication = React.lazy(() => import("./ciods/pages/CiodsPublication"));
const CiodsTeam = React.lazy(() => import("./ciods/pages/CiodsTeam"));
const CiodsContact = React.lazy(() => import("./ciods/pages/CiodsContact"));
const CiodsNews = React.lazy(() => import("./ciods/pages/CiodsNews"));
const CiodsTools = React.lazy(() => import("./ciods/pages/CiodsTools"));
const RajeshR = React.lazy(() => import("./ciods/components/containers/Rajesh"));
const CiodsAdmin = React.lazy(() => import("./ciods/components/Admin/Adminlogin"));
const PubProfCards = React.lazy(() => import("./ciods/components/Admin/PubProfcards"));
const FacultyDetail = React.lazy(() => import("./ciods/components/containers/Faculty"));
// const Newpublication = React.lazy(()=> import("./ciods/components/Admin/Newpublication"));

//IL 24 ROUTES 
const il24 = React.lazy(() => import("./il24/pages/Il24Home"));
const il24Home = React.lazy(() => import("./il24/pages/Il24Image"));

//DRUG RESISTANT ROUTES
const DrugResistant = React.lazy(() => import("./drug_resistant/pages/DrugResistant"));
const DrugHome = React.lazy(() => import("./drug_resistant/pages/DrugHome"));
const DrugResistanceAnalysis = React.lazy(() => import("./drug_resistant/pages/DrugResistanceAnalysis"));
const BrowserInput = React.lazy(() => import("./drug_resistant/pages/BrowseInput"));
const BrowserOutput = React.lazy(() => import("./drug_resistant/components/details/BrowserOutput"));
const QueryForm = React.lazy(() => import("./drug_resistant/pages/QueryForm"));
const QueryOutput = React.lazy(() => import("./drug_resistant/components/details/QueryOutput"));
const Pathway = React.lazy(() => import("./drug_resistant/pages/Pathway"));
const ViewPage = React.lazy(() => import("./drug_resistant/components/details/ViewPage"));
const Download = React.lazy(() => import("./drug_resistant/pages/Download"));
const DFaqs = React.lazy(() => import("./drug_resistant/pages/Faqs"));
const DContact = React.lazy(() => import("./drug_resistant/pages/Contact"));

//PROTEOARK ROUTES
const ProteoArk = React.lazy(() => import("./proteoark/pages/ProteoArk"));
const ProteoHome = React.lazy(() => import("./proteoark/pages/ProteoHome"));
const Login = React.lazy(() => import("./proteoark/pages/AuthPage"));
const Input = React.lazy(() => import("./proteoark/pages/Input"));
const InputLabelFree = React.lazy(() => import("./proteoark/pages/InputLabelFree"));
const InputDexp = React.lazy(() => import("./proteoark/pages/InputDexp"));
const DataVisualPlots = React.lazy(() => import("./proteoark/pages/DataVisualPlots"));
const InputFile = React.lazy(() => import("./proteoark/components/containers/InputFile"));
const InputDataNorm = React.lazy(() => import("./proteoark/components/containers/InputDataNorm"));
const DataNormValue = React.lazy(() => import("./proteoark/pages/DataNormValue"));
const LabelFreeOutput = React.lazy(() => import("./proteoark/pages/LabelFreeOutput"));
const InputDexpOutput = React.lazy(() => import("./proteoark/components/Components/InputDexpOutput"));
const ProteoFaqs = React.lazy(() => import("./proteoark/pages/ProteoFaqs"));
const ProteoContact = React.lazy(() => import("./proteoark/pages/ProteoContact"));
const ProteoDockerPage = React.lazy(() => import("./proteoark/pages/ProteoDockerPage"));
const ProteoTeam = React.lazy(() => import("./proteoark/pages/ProteoTeam"));
const VisualPlot = React.lazy(() => import("./proteoark/pages/VisualPlot"));



//VIRHOST ROUTES
const VirhostLncr = React.lazy(() => import("./virhostlncr/pages/VirhostLncr"));
const VirhostHome = React.lazy(() => import("./virhostlncr/pages/VirhostHome"));
const VirhostVirusList = React.lazy(() => import("./virhostlncr/pages/VirhostVirusList"));
const VirusDetails = React.lazy(() => import("./virhostlncr/components/details/VirusDetails"));
const VirhostLncrnaList = React.lazy(() => import("./virhostlncr/pages/VirhostLncrnaList"));
const LncrnaDetails = React.lazy(() => import("./virhostlncr/components/details/LncrnaDetails"));
const VirhostTargetList = React.lazy(() => import("./virhostlncr/pages/VirhostTargetList"));
const TargetDetails = React.lazy(() => import("./virhostlncr/components/details/TargetDetails"));
const BatchQuery = React.lazy(() => import("./virhostlncr/pages/BatchQuery"));
const BatchQueryResults = React.lazy(() => import("./virhostlncr/components/details/BatchQueryResults"));
const SearchResults = React.lazy(() => import("./virhostlncr/components/details/SearchResults"));
const FAQs = React.lazy(() => import("./virhostlncr/pages/Faqs"));
const ContactUS = React.lazy(() => import("./virhostlncr/pages/ContactUs"));


//HOMEODB ROUTES
const Homoeomicsdb = React.lazy(() => import("./Homoeomicsdb/pages/HomoeOmicsdb"))
const HomeodbHome = React.lazy(() => import("./Homoeomicsdb/pages/HomeodbHome"))
const HomeoBrowse = React.lazy(() => import("./Homoeomicsdb/pages/HomeoBrowse"))
const HomeoDataSubmission = React.lazy(() => import("./Homoeomicsdb/pages/HomeoDataSubmission"))
const HomeoContributors = React.lazy(() => import("./Homoeomicsdb/pages/HomeoContributors"))
const HomeoFaq = React.lazy(() => import("./Homoeomicsdb/pages/HomeoFaq"))
const HomeoContact = React.lazy(() => import("./Homoeomicsdb/pages/HomeoContact"))
const HomeoDrug = React.lazy(() => import("./Homoeomicsdb/pages/HomeoDrug"))
const HomeoDisease = React.lazy(() => import("./Homoeomicsdb/pages/HomeoDisease"))
const HomeoGene = React.lazy(() => import("./Homoeomicsdb/pages/HomeoGene"))
const HomeoCytoscape = React.lazy(() => import("./Homoeomicsdb/pages/HomeoCytoscape"))


//GCPDB ROUTES
const GcpDB = React.lazy(() => import("./GcpDB/pages/GcpDB"))
const GcpDBHome = React.lazy(() => import("./GcpDB/pages/GcpDBHome"))
const GcpDBBquery = React.lazy(() => import("./GcpDB/pages/GcpDBBquery"))
const GcpdbBq_result = React.lazy(() => import("./GcpDB/Containers/bq_result"))
const GcpDBFunctionalAnalysis = React.lazy(() => import("./GcpDB/pages/GcpDBFunctionalAnalysis"))
const analyse_data = React.lazy(() => import("./GcpDB/Containers/analyse_data"))
const analyse_data_result = React.lazy(() => import("./GcpDB/Containers/analyse_data_result"))
const ExcelDataDisplay = React.lazy(() => import("./GcpDB/Containers/ExcelDataDisplay"))
const GcpDBProteinPanels = React.lazy(() => import("./GcpDB/pages/GcpDBProteinPanels"))
const GcpDBProteotypicPeptides = React.lazy(() => import("./GcpDB/pages/GcpDBProteotypicPeptides"))
const GcpdbPq_result = React.lazy(() => import("./GcpDB/Containers/pepqueary_result"))
const GcpDBDataSubmissionPortal = React.lazy(() => import("./GcpDB/pages/GcpDBDataSubmissionPortal"))
const GcpDBContributors = React.lazy(() => import("./GcpDB/pages/GcpDBContributors"))
const GcpDBFaq = React.lazy(() => import("./GcpDB/pages/GcpDBFaq"))
const GcpDBContactUs = React.lazy(() => import("./GcpDB/pages/GcpDBContactUs"))



//PXKD ROUTES
const pxkd = React.lazy(() => import("./pxkd/pages/pxkd"))
const pxkdHome = React.lazy(() => import("./pxkd/pages/pxkdHome"))
const KinaseDetailPage = React.lazy(() => import("./pxkd/pages/KinaseDetailPage"))
const ConservationPage = React.lazy(() => import("./pxkd/pages/ConservationPage"))
const Plotresult = React.lazy(() => import("./pxkd/pages/Plotresult"))
const contact = React.lazy(() => import("./pxkd/pages/contactus"))


// ISOPROT
const Isoprot = React.lazy(() => import("./Isoprot/pages/IsoprotOutlet"))
const IsoprotHome = React.lazy(() => import("./Isoprot/pages/IsoprotHome"))
const IsoprotTabs = React.lazy(() => import("./Isoprot/pages/IsoprotTabs"))
const Isoprotfaq = React.lazy(() => import("./Isoprot/pages/IsoprotFaq"))
const IsoprotHelp = React.lazy(() => import("./Isoprot/pages/IsoprotHelp"))
const IsoprotDownload = React.lazy(() => import("./Isoprot/pages/download"))

const IsoprotContact = React.lazy(() => import("./Isoprot/pages/contact"))

// const Toplogy = React.lazy(() => import("./Isoprot/components/containers/Toplogy"))


//LOLLIPOP ROUTES
const lollipop_plot = React.lazy(() => import("./lollipop_plot/pages/lollipop"))
const lollipop_plot_Home = React.lazy(() => import("./lollipop_plot/pages/home"))
const lollipop_plot_submit_form = React.lazy(() => import("./lollipop_plot/container/submissionform"))
const lollipop_plot_download = React.lazy(() => import("./lollipop_plot/container/plot"))

//LOLLIPOP EXTERNAL ROUTES

const lollipop = React.lazy(() => import("./M2Viz/pages/m2viz"))
const lollipop_Home = React.lazy(() => import("./M2Viz/pages/m2vizhome"))
const lollipop__submit_form = React.lazy(() => import("./M2Viz/container/submitform_protein"))
const lollipop_dna_submit_form = React.lazy(() => import("./M2Viz/container/submitform_dna"))
const lollipop_download = React.lazy(() => import("./M2Viz/container/plot"))
const lollipop_contact = React.lazy(() => import("./M2Viz/pages/m2vizcontact"))
const lollipop_cards = React.lazy(() => import("./M2Viz/container/card"))
const lollipop_Help = React.lazy(() => import("./M2Viz/pages/m2viz_faq"))
// const lollipop_mut_met_cards=React.lazy(() => import("./M2Viz/container/card_meth_mut"))

//BCDRDB ROUTES
const bcdrdb = React.lazy(() => import("./bcdrdb/pages/bcdrdb"))
const bcdrdb_home = React.lazy(() => import("./bcdrdb/pages/bcdrdb_home"))
const bcdrdb_heatmap = React.lazy(() => import("./bcdrdb/pages/bcdrdb_heatmap"))
const bcdrdb_browse = React.lazy(() => import("./bcdrdb/pages/Browse"))
const bcdrdb_new = React.lazy(() => import("./bcdrdb/pages/exceldata"))
const bcdrdb_drugs = React.lazy(() => import("./bcdrdb/pages/drugs"))
const bcdrdb_faq = React.lazy(() => import("./bcdrdb/pages/FAQ"))
const bcdrdb_contact = React.lazy(()=>import("./bcdrdb/pages/contact"))

//TSP ROUTES
const TspOutlet = React.lazy(() => import("./Transcript/pages/TspOutlet"))
const TSP_Align = React.lazy(() => import("./Transcript/pages/alignment"))
const TSP_HOME = React.lazy(() => import("./Transcript/pages/tsp_home"))


//CYTO_KINSUB ROUTES
const cyto_kinsub = React.lazy(() => import("./cyto_kinsub/pages/CytoKinsub"))
const cyto_kinsubHome = React.lazy(() => import("./cyto_kinsub/pages/CytoKinsubHome"))

//OMICS2METABOLITE
const metabolite = React.lazy(() => import("./metabolite/pages/Metabolite"))
const metaboliteHome = React.lazy(() => import("./metabolite/pages/MetaboliteHome"))
const metaboliteAbout = React.lazy(() => import("./metabolite/pages/MetaboliteAbout"))
const metaboliteService = React.lazy(() => import("./metabolite/pages/MetaboliteServices"))
const metaboliteContact = React.lazy(() => import("./metabolite/pages/MetaboliteContact"))
const metaboliteSearch = React.lazy(() => import("./metabolite/pages/MetaboliteSearch"))
const pathwaySearch = React.lazy(() => import("./metabolite/container/MetabolicPathwayVisualizer"))
const ToolSection = React.lazy(() => import("./metabolite/pages/ToolSection"))
const MetaSearch = React.lazy(() => import("./metabolite/pages/MetabolitTool"))
const KinPage = React.lazy(() => import("./metabolite/pages/KinasePage"))



//KR_MApping

const krmap = React.lazy(() => import("./KRMap/Pages/krmap"))
const krmaphome = React.lazy(() => import("./KRMap/Pages/krmaphome"))
const KrmapResults = React.lazy(() => import("./KRMap/Container/cytoresult"))
const Krmapregulationresult = React.lazy(() => import("./KRMap/Container/regulationcyto"))

//Kinasedisorder prediction
const KinDisPredHome = React.lazy(() => import("./KinDisPred/Pages/KinDisPredHome"))
const kindis = React.lazy(() => import("./KinDisPred/Pages/kindispred"));
const PredictionResult = React.lazy(() => import("./KinDisPred/Container/result"));


//CalNetDb 
const CalNetDb = React.lazy(() => import("./CalNetDb/pages/CalNetDb"));
const CalNetHome = React.lazy(() => import("./CalNetDb/pages/CalNetHome"));
const CalNetTabs = React.lazy(() => import("./CalNetDb/pages/Tabs"));


//HOMOVIRPATH
const Homovir = React.lazy(() => import("./HomoVirPath/Pages/HomoVir"));
const HomoVirhome = React.lazy(() => import("./HomoVirPath/Pages/HomoVirHome"));
const PlasmaProfile = React.lazy(() => import("./HomoVirPath/Containers/plasmaProfile"));
const PlasmaDifferential = React.lazy(() => import("./HomoVirPath/Containers/plasmaDiff"));
const SerumProfile = React.lazy(() => import("./HomoVirPath/Containers/serumProfile"));
const SerumDifferential = React.lazy(() => import("./HomoVirPath/Containers/serumDiff"));
const FunctionalAnalysis = React.lazy(() => import("./HomoVirPath/Components/Analysis/Functional_analysisi"));
const BatchQueary = React.lazy(() => import("./HomoVirPath/Pages/Batch_Queary"))
const BatchQuearyResult = React.lazy(() => import("./HomoVirPath/Containers/bquery_result"))
const CrossVirusAnalysis = React.lazy(() => import("./HomoVirPath/Components/Analysis/cross_virus_analysis"))
const HumanviralProteinNetwork = React.lazy(() => import("./HomoVirPath/Components/Analysis/humanviral_prtn_ntwrk"))
const Analysis = React.lazy(() => import("./HomoVirPath/Pages/analysis"))
const DifferentialExpressionAnalysis = React.lazy(() => import("./HomoVirPath/Components/Myanalysis/pvalue"));
const GeneOntologyAnalysis = React.lazy(() => import("./HomoVirPath/Components/Myanalysis/gprofiler"));
const keggPathwayAnalysis = React.lazy(() => import("./HomoVirPath/Components/Myanalysis/keggpathway"));
const HVPPIAnalysis = React.lazy(() => import("./HomoVirPath/Components/Myanalysis/HVPPI"));
const HPPIAnalysis = React.lazy(() => import("./HomoVirPath/Components/Myanalysis/HPPI"));
const Threeanalysis = React.lazy(() => import("./HomoVirPath/Pages/threeanalysis"))
const Searchcard = React.lazy(() => import("./HomoVirPath/Pages/searchcard"))
const DataSubmission = React.lazy(() => import("./HomoVirPath/Pages/datasubmission"))
const  Statistics = React.lazy(() => import("./HomoVirPath/Pages/statistics"))
const Homovir_Contact= React.lazy(() => import("./HomoVirPath/Pages/Contact"))


// error
const NotFound = React.lazy(() => import("./common/components/Error"));


// VIRALOMICS
// const ViralOm = React.lazy(() => import("./ViralOmics/pages/ViralOm"));

const ViralomicsHome = React.lazy(() => import("./ViralOmics/pages/Home"));
const ViralAbout = React.lazy(() => import("./ViralOmics/pages/About"));
const Database = React.lazy(() => import("./ViralOmics/pages/Database"));
const Tools = React.lazy(() => import("./ViralOmics/pages/Tools"));
const Contact = React.lazy(() => import("./ViralOmics/pages/Contact"));
const Results = React.lazy(() => import("./ViralOmics/pages/Results"));
const GSEDetails = React.lazy(() => import("./ViralOmics/pages/GseDetails"));
const AnalyseResults = React.lazy(() => import("./ViralOmics/pages/AnalysisResults"));
const crossData = React.lazy(() => import("./ViralOmics/pages/ResultPage"));

// Affinix
const Affinix = React.lazy(() => import("./affinix/pages/AffinixHome"));
const AffinixPrediction = React.lazy(() => import("./affinix/pages/AffinixAnalyse"));



// AutoPhospho
const AutoPhospho = React.lazy(() => import("./AutoPhospho/pages/autophospho"));
const AutoPhosphoHome = React.lazy(() => import("./AutoPhospho/pages/autophosphoHome"));
const AutoKinaseDetailPage = React.lazy(() => import("./AutoPhospho/pages/kinaseDetail"));
const autophosphoContact = React.lazy(() => import("./AutoPhospho/pages/contact"))

// RetinaIntel
const RetinaIntel = React.lazy(() => import("./RetinaIntel/App"));

// Ciods Connect
const LoginPage = React.lazy(() => import("./ciodsconnect/LoginPage"));
const Dashboard = React.lazy(() => import("./ciodsconnect/Dashboard"));
const OrganisationDashboard = React.lazy(() => import("./ciodsconnect/pages/OrganisationDashboard"));
const OrganisationPublicationsPage = React.lazy(() => import("./ciodsconnect/pages/OrganisationPublicationsPage"));
const EmployeesPage = React.lazy(() => import("./ciodsconnect/pages/EmployeesPage"));
const EmployeeProfilePage = React.lazy(() => import("./ciodsconnect/pages/EmployeeProfilePage"));
const TeamsPage = React.lazy(() => import("./ciodsconnect/pages/TeamsPage"));
const TeamStatisticsPage = React.lazy(() => import("./ciodsconnect/pages/TeamStatisticsPage"));
const TeamManagementPage = React.lazy(() => import("./ciodsconnect/pages/TeamManagementPage"));
const AccountManagementPage = React.lazy(() => import("./ciodsconnect/pages/AccountManagementPage"));
const SecuritySettingsPage = React.lazy(() => import("./ciodsconnect/pages/SecuritySettingsPage"));
const PublicationTrackerPage = React.lazy(() => import("./ciodsconnect/pages/PublicationTrackerPage"));

const PortalTasks = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.Tasks })));
const PortalPublications = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.Publications })));
const PortalFunding = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.Funding })));
const PortalPatents = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.Patents })));
const PortalAchievements = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.Achievements })));
const FacultyTeamOverview = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.FacultyTeamOverviewRouter })));
const PortalDashboard = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.DashboardRouter })));
const PortalCalendar = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.CalendarRouter })));
const LeadershipPublications = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.LeadershipPublicationsRouter })));
const PortalPerformance = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.PerformanceRouter })));
const PortalActivity = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.ActivityRouter })));
const PortalTeams = React.lazy(() => import("./ciodsconnect/ResourcePages").then(m => ({ default: m.TeamsPage })));
const PortalNotifications = React.lazy(() => import("./ciodsconnect/pages/LeadershipRoutePages").then(m => ({ default: m.NotificationsRouter })));




export const routesConfig = [
  {
    path: "/",
    component: Ciods,
    children: [
      { index: true, component: CiodsHome },
      { path: "Publication", component: CiodsPublication },
      { path: "team", component: CiodsTeam },
      { path: "contact", component: CiodsContact },
      { path: "tools", component: CiodsTools },
      { path: "team/rajesh", component: RajeshR },
      { path: "team/faculty/:id", component: FacultyDetail },
      { path: "news", component: CiodsNews },
      { path: "ciodsadmin", component: CiodsAdmin },
      // {path:"newpublication", component:Newpublication},
      {
        path: "pubprofcards",
        component: () => (
          <PrivateRouteAdmin>
            <PubProfCards />
          </PrivateRouteAdmin>
        ),
      },
    ],


  },
  {
    path: "VirhostlncR",
    component: VirhostLncr,
    children: [
      { index: true, component: VirhostHome },
      { path: "virus_list", component: VirhostVirusList },
      { path: "virus_details/:virus", component: VirusDetails },
      { path: "lncrna_list", component: VirhostLncrnaList },
      { path: "lncrna_Details/:lncrna", component: LncrnaDetails },
      { path: "target_list", component: VirhostTargetList },
      { path: "target_Details/:targetId", component: TargetDetails },
      { path: "BatchQuery", component: BatchQuery },
      { path: "BatchQueryResults", component: BatchQueryResults },
      { path: "search", component: SearchResults },
      { path: "FAQs", component: FAQs },
      { path: "contact", component: ContactUS },

    ],
  },
  {
    path: "drug_resistant",
    component: DrugResistant,
    children: [
      { index: true, component: DrugHome },
      { path: "DrugResistanceAnalysis", component: DrugResistanceAnalysis },
      { path: "BrowseInput", component: BrowserInput },
      { path: "BrowserOutput", component: BrowserOutput },
      { path: "QueryForm", component: QueryForm },
      { path: "QueryOutput", component: QueryOutput },
      { path: "Pathway", component: Pathway },
      { path: "Viewpage", component: ViewPage },
      { path: "Download", component: Download },
      { path: "DFaqs", component: DFaqs },
      { path: "Contact", component: DContact },

    ],
  },

  {
    path: "proteoark",
    component: ProteoArk,
    children: [
      { index: true, component: ProteoHome },
      { path: "login", component: Login },
      {
        path: "input", component: () => (
          <PrivateRoute>
            <Input />
          </PrivateRoute>
        ),
      },
      {
        path: "input_label_free",
        component: () => (
          <PrivateRoute>
            <InputLabelFree />
          </PrivateRoute>
        ),
      },
      {
        path: "inputDexp",
        component: () => (
          <PrivateRoute>
            <InputDexp />
          </PrivateRoute>
        ),

      },
      {
        path: "allplots",
        component: () => (
          <PrivateRoute>
            <DataVisualPlots />
          </PrivateRoute>
        ),
      },
      {
        path: "inputfile",
        component: () => (
          <PrivateRoute>
            <InputFile />
          </PrivateRoute>
        ),
      },
      {
        path: "datanorm",
        component: () => (
          <PrivateRoute>
            < InputDataNorm />
          </PrivateRoute>
        ),
      },
      {
        path: "pvalue/:analysis_id",
        component: () => (
          <PrivateRoute>
            < DataNormValue />
          </PrivateRoute>
        ),
      },
      {
        path: "labelfreeoutput",
        component: () => (
          <PrivateRoute>
            <  LabelFreeOutput />
          </PrivateRoute>
        ),
      },
      {
        path: "InputfDexp",
        component: () => (
          <PrivateRoute>
            <    InputDexpOutput />
          </PrivateRoute>
        ),
      },

      {
        path: "dockerpage",
        component: () => (
          <PrivateRoute>
            <   ProteoDockerPage />
          </PrivateRoute>
        ),
      },
      { path: "faqs", component: ProteoFaqs },
      { path: "contact", component: ProteoContact },
      { path: "team", component: ProteoTeam },
      { path: "visualplot", component: VisualPlot },

    ],
  },

  {
    path: "homoeomicsdb",
    component: Homoeomicsdb,
    children: [
      { index: true, component: HomeodbHome },
      { path: "browse", component: HomeoBrowse },
      { path: "data-submission", component: HomeoDataSubmission },
      { path: "contributors", component: HomeoContributors },
      { path: "faq", component: HomeoFaq },
      { path: "contactus", component: HomeoContact },
      { path: "browse/drug", component: HomeoDrug },
      { path: "browse/disease", component: HomeoDisease },
      { path: "browse/gene", component: HomeoGene },
      { path: "cytoscape", component: HomeoCytoscape },
    ],
  },

  {
    path: "gcpdb",
    component: GcpDB,
    children: [
      { index: true, component: GcpDBHome },
      { path: "bquery", component: GcpDBBquery },
      { path: "bqresult", component: GcpdbBq_result },
      { path: "functional_analysis", component: GcpDBFunctionalAnalysis },
      { path: "analysedata", component: analyse_data },
      { path: "analysedataresult", component: analyse_data_result },
      { path: "exceldaata_display", component: ExcelDataDisplay },
      { path: "protein_panels", component: GcpDBProteinPanels },
      { path: "proteotypic_peptides", component: GcpDBProteotypicPeptides },
      { path: "pepqresult", component: GcpdbPq_result },
      { path: "Data_submission_portal", component: GcpDBDataSubmissionPortal },
      { path: "contributors", component: GcpDBContributors },
      { path: "faq", component: GcpDBFaq },
      { path: "contact", component: GcpDBContactUs }
    ],
  },

  {
    path: "pxkd",
    component: pxkd,
    children: [
      { index: true, component: pxkdHome },
      { path: "kinase_details/:kinaseName", component: KinaseDetailPage },
      { path: "conservation", component: ConservationPage },
      { path: "kinase_plot/:type/:value", component: Plotresult },
      { path: "contact", component: contact }

    ],
  },

  {
    path: "isoprodb",
    component: Isoprot,
    children: [
      { index: true, component: IsoprotHome },
      { path: "/isoprodb/:gene", component: IsoprotTabs }, // Changed from tab to IsoprotTabs
      { path: "faq", component: Isoprotfaq },
      { path: "contact", component: IsoprotContact },
      { path: "help", component: IsoprotHelp },
      { path: "download", component: IsoprotDownload }

    ],
  },

  //lollipop internal
  {
    path: "lollipopplot",
    component: lollipop_plot,
    children: [
      { index: true, component: lollipop_plot_Home },

      { path: "submit", component: lollipop_plot_submit_form },
      { path: "download", component: lollipop_plot_download }


    ],
  },

  {
    path: "m2viz",
    component: lollipop,
    children: [
      { index: true, component: lollipop_Home },
      { path: "/m2viz/:category/:selectedOption", component: lollipop_cards },
      { path: "/m2viz/protein/:selectedOption/:selectedType", component: lollipop__submit_form },
      { path: "/m2viz/dna/:selectedOption/:selectedType", component: lollipop_dna_submit_form },
      { path: "/m2viz/protein/:selectedOption/:selectedType/:ACCESSION", component: lollipop_download },
      { path: "/m2viz/dna/:selectedOption/:selectedType/:ENSG", component: lollipop_download },
      { path: "contact", component: lollipop_contact },
      { path: "faq", component: lollipop_Help }
    ],
  },

  {
    path: "bcdrdb",
    component: bcdrdb,
    children: [
      { index: true, component: bcdrdb_home },
      { path: "heatmap", component: bcdrdb_heatmap },
      { path :"browse", component:bcdrdb_browse},
      {path : "new", component:bcdrdb_new},
      {path : "drugs", component :bcdrdb_drugs},
      {path:"faq",component :bcdrdb_faq},
      {path: "contact_us",component :bcdrdb_contact}

    ],
  },

  {
    path: "tsp",
    component: TspOutlet,
    children: [
      { index: true, component: TSP_HOME },

      { path: "align/:type/:family", component: TSP_Align },
      // { path: "alignment", component: AlignmentResults },
      // { path: "topology", component: Toplogy },



    ],

  },

  {
    path: "cyto_kinsub",
    component: cyto_kinsub,
    children: [
      { index: true, component: cyto_kinsubHome },


    ],
  },

  {
    path: "metabolite",
    component: metabolite,
    children: [
      { index: true, component: metaboliteHome },
      { path: "about", component: metaboliteAbout },
      { path: "service", component: metaboliteService },
      { path: "contact", component: metaboliteContact },
      { path: "metaboliteIn", component: metaboliteSearch },
      { path: "proteinIn", component: metaboliteSearch },
      { path: "ptmIn", component: metaboliteSearch },
      { path: "pathways", component: pathwaySearch },
      { path: "tools", component: ToolSection },
      { path: "metasearch", component: MetaSearch },
      { path: "kinaseIn", component: KinPage },


    ],
  },
  {
    path: "phorus",
    component: krmap,
    children: [
      { index: true, component: krmaphome },
      { path: "reg", component: KrmapResults },
      { path: "diff", component: Krmapregulationresult },

    ],
  },

  {
    path: "kindisorder",
    component: kindis,
    children: [
      { index: true, component: KinDisPredHome },
      { path: "results", component: PredictionResult },


    ],
  },

  {
    path: "il24/",
    component: il24,
    children: [
      { index: true, component: il24Home },


    ],
  },


  {
    path: "il24/",
    component: il24,
    children: [
      { index: true, component: il24Home },


    ],
  },

  {
    path: "calnet",
    component: CalNetDb,
    children: [
      { index: true, component: CalNetHome },
      { path: "gene/:geneSymbol", component: CalNetTabs },
    ],
  },


  {
  path: "homovir",
  component: Homovir,
  children: [
    { index: true, component: HomoVirhome },
    { path: "serumprof", component: SerumProfile },
    { path: "serumdiff", component: SerumDifferential },
    { path: "plasmaprof", component: PlasmaProfile },
    { path: "plasmadiff", component: PlasmaDifferential },
    { path: "functional_analysis", component: FunctionalAnalysis },
    {path: "batch_query", component: BatchQueary},
    {path: "crossVirusAnalysis", component: CrossVirusAnalysis},
    {path: "humanviral_protein_network", component: HumanviralProteinNetwork},
    {path: "myanalysis", component: Analysis},
    {path: "differential_expression_analysis", component: DifferentialExpressionAnalysis},
    {path: "gene_ontology_analysis", component: GeneOntologyAnalysis},
    {path: "kegg_pathway_analysis", component: keggPathwayAnalysis},
    {path: "human_viral_ppi_analysis", component: HVPPIAnalysis},
    {path: "human_ppi_analysis", component: HPPIAnalysis},
    {path: "analysis", component: Threeanalysis},
    {path: "search", component: Searchcard},
    {path:"data_submission", component: DataSubmission},
    {path:"about", component: Statistics},
    {path:"qresults", component: BatchQuearyResult},
    {path:"contact",component:Homovir_Contact}

  ]
},

  {
    path: "*",
    component: NotFound,
  },

  {
    path: "viralomics",
    component: ViralOm,
    children: [
      { index: true, component: ViralomicsHome },
      { path: "about", component: ViralAbout },
      { path: "database", component: Database },
      { path: "tools", component: Tools },
      { path: "contact", component: Contact },
      { path: "results", component: Results },
      { path: "gse/:gseId", component: GSEDetails },
      { path: "analyse_results", component: AnalyseResults },
      { path: "cross_data_results", component: crossData }
    ],
  },

  
  {
    path: "affinix",
    component: Affinix
  },
  {
    path: "affinix/analyse",
    component: AffinixPrediction
  },


  {
    path: "autophosdb",
    component: AutoPhospho,
    children: [
      { index: true, component: AutoPhosphoHome },
      {path: ":kinaseName", component: AutoKinaseDetailPage },
      { path: "contact", component: autophosphoContact }

    ],
  },

  {
    path: "retinaintel",
    component: RetinaIntel
  },

  {
    path: "ciodsconnect",
    component: ConnectApp,
    children: [
      { index: true, component: LoginPage },
      { path: "login", component: LoginPage },
      { path: "dashboard", component: PortalDashboard },
      { path: "team-overview", component: FacultyTeamOverview },
      { path: "organisation-dashboard", component: OrganisationDashboard },
      { path: "organisation-publications", component: LeadershipPublications },
      { path: "employees", component: EmployeesPage },
      { path: "employees/:userId", component: EmployeeProfilePage },
      { path: "teams", component: TeamsPage },
      { path: "teams/:teamId", component: TeamStatisticsPage },
      { path: "team-management", component: TeamManagementPage },
      { path: "account-management", component: AccountManagementPage },
      { path: "security", component: SecuritySettingsPage },
      { path: "publication-tracker", component: PublicationTrackerPage },

      { path: "tasks", component: PortalTasks },
      { path: "publications", component: PortalPublications },
      { path: "funding", component: PortalFunding },
      { path: "patents", component: PortalPatents },
      { path: "achievements", component: PortalAchievements },
      { path: "calendar", component: PortalCalendar },
      { path: "performance", component: PortalPerformance },
      { path: "activity", component: PortalActivity },
      { path: "notifications", component: PortalNotifications },
    ],
  },


];

